export default function PortailConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('portail');
    $translatePartialLoaderProvider.addPart('chantiers');
}

PortailConfiguration.$inject = ['$translatePartialLoaderProvider'];
